var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1171273733"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 32",
    d: "M9.98884 3.78897L7.17643 0.976562C7.06899 1.20386 7.0134 1.45219 7.01367 1.7036V4.45617H10.6536L9.98884 3.78897Z",
    fill: "url(#paint0_linear_2265_17988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 33",
    d: "M7.65932 1.88312L7.12077 0.892789C6.97474 0.62321 6.75871 0.398 6.49544 0.24088C6.23217 0.0837603 5.9314 0.000545355 5.62481 0L1.7048 0C1.25266 0 0.819035 0.179612 0.499323 0.499323C0.179612 0.819035 0 1.25266 0 1.7048L0 19.791C0 20.0148 0.0440959 20.2365 0.12977 20.4434C0.215444 20.6502 0.341018 20.8381 0.499323 20.9964C0.657628 21.1547 0.845564 21.2803 1.0524 21.366C1.25923 21.4517 1.48092 21.4958 1.7048 21.4958H22.2952C22.5191 21.4958 22.7408 21.4517 22.9476 21.366C23.1544 21.2803 23.3424 21.1547 23.5007 20.9964C23.659 20.8381 23.7846 20.6502 23.8702 20.4434C23.9559 20.2365 24 20.0148 24 19.791V4.592C24 4.36812 23.9559 4.14644 23.8702 3.9396C23.7846 3.73277 23.659 3.54483 23.5007 3.38653C23.3424 3.22822 23.1544 3.10265 22.9476 3.01697C22.7408 2.9313 22.5191 2.8872 22.2952 2.8872H9.34916C9.00311 2.8878 8.66335 2.79479 8.36587 2.61803C8.06838 2.44126 7.82424 2.18733 7.65932 1.88312Z",
    fill: "#FFB949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 34",
    d: "M1.7048 21.4983H22.2952C22.5191 21.4983 22.7408 21.4542 22.9476 21.3685C23.1544 21.2828 23.3424 21.1572 23.5007 20.9989C23.659 20.8406 23.7846 20.6527 23.8702 20.4459C23.9559 20.239 24 20.0173 24 19.7935V6.97488L20.4462 3.42048C20.32 3.26697 20.1642 3.14055 19.9879 3.04882C19.8117 2.9571 19.6187 2.90196 19.4206 2.88672H15.7932C15.5478 2.90602 15.3111 2.98637 15.1047 3.12045C14.8983 3.25454 14.7287 3.4381 14.6113 3.65445L14.147 4.51193C14.0045 4.77524 13.7934 4.99514 13.5362 5.1484C13.279 5.30165 12.9852 5.38256 12.6857 5.38258H1.47622C1.0847 5.38258 0.709219 5.53811 0.432375 5.81495C0.155531 6.0918 1.68042e-06 6.46728 1.68042e-06 6.85879V19.7911C-0.000312926 20.0152 0.0435508 20.2371 0.129084 20.4442C0.214617 20.6513 0.340142 20.8395 0.498478 20.9981C0.656814 21.1567 0.844856 21.2824 1.05185 21.3683C1.25884 21.4541 1.48072 21.4983 1.7048 21.4983Z",
    fill: "url(#paint1_linear_2265_17988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 35",
    d: "M19.9986 7.5546V2.8872H9.34736C9.00164 2.88741 8.66228 2.79423 8.36515 2.61748C8.06802 2.44074 7.82415 2.18702 7.65932 1.88312L7.12077 0.892789C6.97474 0.62321 6.75871 0.398 6.49544 0.24088C6.23217 0.0837603 5.9314 0.000545355 5.62481 0L1.7048 0C1.25266 0 0.819035 0.179612 0.499323 0.499323C0.179612 0.819035 0 1.25266 0 1.7048L0 7.5546H19.9986Z",
    fill: "url(#paint2_linear_2265_17988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 36",
    d: "M21.1018 21.4953H1.67999C1.41211 21.4953 1.15519 21.3888 0.965766 21.1994C0.77634 21.01 0.669922 20.7531 0.669922 20.4852V5.46575C0.669843 5.33306 0.695912 5.20164 0.746638 5.07903C0.797363 4.95641 0.871752 4.84499 0.965554 4.75113C1.05936 4.65728 1.17073 4.58282 1.29332 4.53203C1.4159 4.48123 1.5473 4.45508 1.67999 4.45508H21.1018C21.3696 4.45508 21.6266 4.5615 21.816 4.75092C22.0054 4.94035 22.1118 5.19726 22.1118 5.46515V20.4846C22.1119 20.6173 22.0858 20.7487 22.0351 20.8713C21.9844 20.9939 21.91 21.1054 21.8162 21.1992C21.7224 21.2931 21.611 21.3675 21.4884 21.4183C21.3658 21.4691 21.2344 21.4953 21.1018 21.4953Z",
    fill: "url(#paint3_linear_2265_17988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 37",
    d: "M14.1464 4.51243L14.6113 3.65495C14.7379 3.42109 14.9254 3.22579 15.1539 3.0897C15.3823 2.95361 15.6433 2.88179 15.9092 2.88184H19.3057C19.6972 2.88184 20.0727 3.03737 20.3495 3.31421C20.6264 3.59105 20.7819 3.96653 20.7819 4.35805V19.9819C20.7817 20.1806 20.8207 20.3775 20.8967 20.5612C20.9726 20.7449 21.084 20.9119 21.2245 21.0525C21.365 21.1931 21.5318 21.3047 21.7154 21.3809C21.899 21.4571 22.0958 21.4963 22.2946 21.4964H1.47622C1.28223 21.4965 1.09014 21.4583 0.910923 21.384C0.731707 21.3098 0.568886 21.201 0.431775 21.0638C0.294665 20.9265 0.185955 20.7636 0.111867 20.5843C0.0377787 20.4051 -0.000234912 20.2129 1.09219e-06 20.019V6.8581C1.09219e-06 6.46658 0.15553 6.0911 0.432374 5.81426C0.709218 5.53742 1.0847 5.38188 1.47622 5.38188H12.6857C12.985 5.38194 13.2786 5.30119 13.5357 5.14815C13.7928 4.99511 14.0038 4.77547 14.1464 4.51243Z",
    fill: "url(#paint4_linear_2265_17988)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 38",
    d: "M0 16.29V20.0198C0 20.4113 0.155529 20.7868 0.432373 21.0636C0.709217 21.3404 1.0847 21.496 1.47621 21.496H22.2946C22.0959 21.496 21.8991 21.4568 21.7155 21.3808C21.5319 21.3047 21.365 21.1933 21.2245 21.0527C21.084 20.9122 20.9725 20.7454 20.8965 20.5618C20.8204 20.3782 20.7813 20.1814 20.7813 19.9827V16.2906L0 16.29Z",
    fill: "url(#paint5_linear_2265_17988)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2265_17988",
    x1: 8.93194,
    y1: 4.55708,
    x2: 5.04681,
    y2: 0.300579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E58200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E27F04",
    stopOpacity: 0.039
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#C15D2F",
    stopOpacity: 0.467
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802,
    stopColor: "#AD4949",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A64153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2265_17988",
    x1: 18.768,
    y1: 20.5118,
    x2: 8.36453,
    y2: 3.20081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4003D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    stopColor: "#D21243",
    stopOpacity: 0.106
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#BF274A",
    stopOpacity: 0.267
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446,
    stopColor: "#B1364F",
    stopOpacity: 0.447
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#A83E52",
    stopOpacity: 0.663
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A64153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2265_17988",
    x1: 9.9993,
    y1: 2.68188,
    x2: 9.9993,
    y2: 7.44128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4003D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    stopColor: "#D21243",
    stopOpacity: 0.106
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#BF274A",
    stopOpacity: 0.267
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446,
    stopColor: "#B1364F",
    stopOpacity: 0.447
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#FFB949",
    stopOpacity: 0.663
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2265_17988",
    x1: 8.45333,
    y1: 7.67567,
    x2: 14.7488,
    y2: 25.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#FAF8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404,
    stopColor: "#ECEEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#D5DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#B5C4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1B5D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2265_17988",
    x1: 7.4464,
    y1: 9.22939,
    x2: 20.7051,
    y2: 28.2555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    stopColor: "#FFB949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#FFB949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#FFB949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#FFB949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2265_17988",
    x1: 11.1473,
    y1: 19.5958,
    x2: 11.1473,
    y2: 22.5476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4003D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#D01544",
    stopOpacity: 0.204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#B92D4C",
    stopOpacity: 0.498
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#AB3C51",
    stopOpacity: 0.773
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A64153"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.773e9417afef55492a4f0542a51e2a2e.svg";
export { ForwardRef as ReactComponent };